exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-cashback-program__cashback-program-section--active {\n  margin-bottom: 16px;\n}\n", ""]);

// exports
